const generate = eventName => {
  const event = eventName.split(/(?=[A-Z])/).join('-').toLowerCase();
  const id = Math.random().toString(36).slice(-6);
  return `${event}-${id}`;
};
var eventId = {
  generate
};

export { eventId as default };
